module.exports = __webpack_public_path__ + "static/media/sample_mll_bulk_trainunloading.23aea988.csv";